import { hash, initials } from '../data/mockData';

// Deterministic colored initials: same student, same color, every session.
// Identity marks, not status — the one place pastels are allowed (DESIGN.md §6).
const HUES = [
  { bg: '#DBEAFE', fg: '#1E40AF' }, // blue
  { bg: '#DCFCE7', fg: '#166534' }, // green
  { bg: '#FEF3C7', fg: '#92400E' }, // amber
  { bg: '#F3E8FF', fg: '#6B21A8' }, // purple
  { bg: '#FCE7F3', fg: '#9D174D' }, // pink
  { bg: '#CCFBF1', fg: '#115E59' }, // teal
  { bg: '#FFEDD5', fg: '#9A3412' }, // orange
  { bg: '#E0E7FF', fg: '#3730A3' }, // indigo
];

// `as`: 'span' when the avatar sits inside a sentence (a <div> can't go in a <p>).
export default function Avatar({ name, size = 36, as: Tag = 'div' }) {
  const hue = HUES[hash(name) % HUES.length];
  return (
    <Tag
      className="flex-none rounded-full flex items-center justify-center font-extrabold"
      style={{ width: size, height: size, fontSize: Math.round(size / 2.8), background: hue.bg, color: hue.fg }}
    >
      {initials(name)}
    </Tag>
  );
}
